import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ProductService } from "@app/product/shared/products.service";

@Component({
  selector: "app-client-compliance",
  templateUrl: "./client-compliance.component.html",
  styleUrls: ["./client-compliance.component.css"],
})
export class ClientComplianceComponent implements OnInit {
  @Input() client: any;
  @Input() isEditMode: boolean = false;
  @Input() canEdit: boolean = true;
  @Output() hasChanges = new EventEmitter<boolean>();

  allProducts: any[] = [];
  selectedProductIds: Set<string> = new Set();

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.loadProducts();
    this.initializeSelectedProducts();
  }

  loadProducts() {
    this.productService.list().subscribe({
      next: (products: any[]) => {
        this.allProducts = products;
      },
      error: (error) => {
        console.error("Error loading products:", error);
      },
    });
  }

  initializeSelectedProducts() {
    if (this.client?.products) {
      this.selectedProductIds = new Set(this.client.products.map((cp: any) => cp.productId));
    }
  }

  isProductSelected(productId: string): boolean {
    return this.selectedProductIds.has(productId);
  }

  toggleProduct(product: any) {
    if (this.selectedProductIds.has(product.id)) {
      this.selectedProductIds.delete(product.id);
      this.client.products =
        this.client.products?.filter((cp: any) => cp.productId !== product.id) || [];
    } else {
      this.selectedProductIds.add(product.id);
      if (!this.client.products) {
        this.client.products = [];
      }
      this.client.products.push({
        clientId: this.client.id,
        productId: product.id,
        product: product,
      });
    }
    this.onFieldChange();
  }

  trackByProductId(index: number, product: any): string {
    return product.id;
  }

  onFieldChange() {
    this.hasChanges.emit(true);
  }
}
